// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jKlCBu","pageDesc":"ISyu5j","verifyEmailWrapper":"D4VESt","infoNotice":"psrQ5T","infoIcon":"JMG9yx"};